export default __webpack_public_path__ + "static/media/WMATIC.46419c95.svg";